export default __webpack_public_path__ + "static/media/iconHomeProfile.547c0a8c.svg";